// extracted by mini-css-extract-plugin
module.exports = {"title":"_207dc0"};